import column from '../../../../common/list-table/helpers/columns';

export const viewDeviceSettingsTableColumns = (data) => {
  const { FilteredTextColumn, NotFilteredReadOnlyCheckboxColumn } = column(data);

  const conditionalHide = (row) => row.original.deviceType?.code !== 'D';

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Country', 'country'),
        new FilteredTextColumn('MRD name', 'mrdName'),
        new FilteredTextColumn('Device type', 'deviceType.description'),
        new FilteredTextColumn('MRD status', 'mrdStatus.description'),
        new FilteredTextColumn('IMPC', 'impc'),
        new FilteredTextColumn('Airport (IATA)', 'airport'),
        new FilteredTextColumn('Operator', 'operator'),
        new NotFilteredReadOnlyCheckboxColumn('Print flight barcode', 'printFlightBarcode', true, conditionalHide).withWidth(130),
        new NotFilteredReadOnlyCheckboxColumn('Print start stop barcode', 'printStartStopBarcode', true, conditionalHide).withWidth(130),
        new NotFilteredReadOnlyCheckboxColumn('Ticket button', 'ticketButton', true, conditionalHide).withWidth(130),
        new NotFilteredReadOnlyCheckboxColumn('Flight info button', 'flightInfoButton', true, conditionalHide).withWidth(130),
        new NotFilteredReadOnlyCheckboxColumn('Manual entry option', 'manualEntryOption', true, conditionalHide).withWidth(130),
      ],
    },
  ];
};

export const editDeviceSettingsTableColumns = (data, setData) => {
  const { FilteredTextColumn, EditableCheckboxColumn } = column(data);

  const conditionalHide = (row) => row.original.deviceType?.code !== 'D';

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Country', 'country'),
        new FilteredTextColumn('MRD name', 'mrdName'),
        new FilteredTextColumn('Device type', 'deviceType.description'),
        new FilteredTextColumn('MRD status', 'mrdStatus.description'),
        new FilteredTextColumn('IMPC', 'impc'),
        new FilteredTextColumn('Airport (IATA)', 'airport'),
        new FilteredTextColumn('Operator', 'operator'),
        new EditableCheckboxColumn('Print flight barcode', 'printFlightBarcode', true, data, setData, conditionalHide).withWidth(130),
        new EditableCheckboxColumn('Print start stop barcode', 'printStartStopBarcode', true, data, setData, conditionalHide).withWidth(130),
        new EditableCheckboxColumn('Ticket button', 'ticketButton', true, data, setData, conditionalHide).withWidth(130),
        new EditableCheckboxColumn('Flight info button', 'flightInfoButton', true, data, setData, conditionalHide).withWidth(130),
        new EditableCheckboxColumn('Manual entry option', 'manualEntryOption', true, data, setData, conditionalHide).withWidth(130),
      ],
    },
  ];
};
